
import CardPropertyObjectTable from '../../components/Card/CardPropertyObjectTable.vue'
import ItemsSearchDialog from '../../components/Field/ItemsSearchDialog.vue'

export default {
  name: 'ServiceObjectPropertyAdjacentChildren',
  extends: CardPropertyObjectTable,
  data: function () {
    let componentProps = this.tabProp.componentProps
    if (!componentProps) {
      componentProps = {}
      this.$set(this.tabProp, 'componentProps', componentProps)
    }
    this.$set(this.tabProp.componentProps, 'hideHeader', false)
    this.$set(this.tabProp.componentProps, 'fulltext', true)

    return {
    }
  },
  computed: {
    columns: function () {
      const columns = []
      columns.push(this.getColumnConfig({
        name: 'name',
        label: 'Смежные объекты',
        type: 'string',
        format: val => {
          const row = this.rows.find(row => row.name === val)
          return row.parentAdjacentObjects.length > 1 ? `${val} (+)` : val
        },
        componentProps: {
          tooltip: (row, val) => {
            return row.parentAdjacentObjects.length
              ? `Смежные объекты (корневые):
            ${row.parentAdjacentObjects.map((adjacent) => {
              return adjacent.name
            }).join('\n')}` : 'Нет смежных корневых объектов'
          },
          noExtraFormat: true
        }
      }))
      columns.push(this.getColumnConfig({
        name: 'viewObjectDistanceText',
        label: 'Расстояние (по прямой)',
        type: 'string',
        sort: (a, b, rowA, rowB) => {
          if (isNaN(parseFloat(a)) && isNaN(parseFloat(b))) {
            return 0
          } else if (isNaN(parseFloat(a))) {
            return 1
          } else if (isNaN(parseFloat(b))) {
            return -1
          }
          return parseFloat(a) - parseFloat(b)
        }
      }))
      return columns
    },
    rows: function () {
      if (this.object && this.object._serviceObject) {
        return this.object._serviceObject[this.tabProp.key]
      } else if (this.object) {
        return this.object[this.tabProp.key]
      } else {
        return []
      }
    },
    serviceObject: function () {
      return (this.object && this.object._serviceObject) || null
    }
  },
  methods: {
    // @Override
    onShowSelectionDialog: function () {
      this.$q.dialog({
        component: ItemsSearchDialog,
        parent: this,
        config: {
          headerLabel: this.componentProps.dialogLabel,
          value: this.object[this.tabProp.key],
          store: this.objectFieldConfig.store,
          multiple: true, // TODO this.multiple
          onApply: items => {
            this.object[this.tabProp.key] = items
            items.forEach(item => {
              if (!this.object._serviceObject.adjacentObjects.find(adjacent => adjacent.id === item.id)) {
                this.object._serviceObject.adjacentObjects.push({
                  id: item.id,
                  name: item.name,
                  key: item.key,
                  type: item.type,
                  parentAdjacentObjects: []
                })
              }
            })
          }
        }
      })
    },

    // @Override
    onDeleteRow: function (row) {
      const index = this.object[this.tabProp.key].findIndex(adjacent => adjacent.id === row.id)
      if (index !== -1) {
        this.object[this.tabProp.key].splice(index, 1)
      }
      const adjacentIndex = this.object._serviceObject.adjacentObjects.findIndex(adjacent => adjacent.id === row.id)
      if (adjacentIndex !== -1) {
        this.object._serviceObject.adjacentObjects.splice(adjacentIndex, 1)
      }
    }
  }
}
